import React, { Component } from 'react'
import s from './Quiz.scss'
import { Form, Field, reduxForm } from 'redux-form'
import Radio from 'components/Input/Radio'
import Button from 'components/Button'
import { Col, Row } from '../Layout'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import IconCloseThin from 'components/Icons/CloseThin'
import AnimationFade from 'components/Animation/AnimationFade'
import Markdown from '../../features/Markdown'

const questions = [
  {
    id: 'companyType',
    label: 'type type of business are you?',
    options: [
      {
        label: 'Sole Trader',
        value: 'sole-trader',
      },
      {
        label: 'Company',
        value: 'company',
      },
      {
        label: 'Call Centre',
        value: 'call-centre',
      },
    ],
  },
  {
    id: 'callVolume',
    label: "What's your call volume like?",
    options: [
      {
        label: 'Few calls a day',
        value: 'low',
      },
      {
        label: 'Few calls an hour',
        value: 'medium',
      },
      {
        label: 'Phone rings off the hook',
        value: 'high',
      },
    ],
  },
  {
    id: 'callFlows',
    label: 'How often does your business need to make changes to call flows?',
    options: [
      {
        label: 'Never',
        value: 'low',
      },
      {
        label: 'Sometimes',
        value: 'medium',
      },
      {
        label: 'All the time',
        value: 'high',
      },
    ],
  },
  {
    id: 'work',
    label: 'How do you like to work?',
    options: [
      {
        label: 'On the go',
        value: 'mobile',
      },
      {
        label: 'In the office',
        value: 'landline',
      },
      {
        label: 'Both',
        value: 'both',
      },
    ],
  },
  {
    id: 'outbound',
    label: 'Do you need to make outgoing calls?',
    options: [
      {
        label: 'Yes',
        value: 'yes',
      },
      {
        label: 'No',
        value: 'no',
      },
    ],
  },
]

const getPlanName = data => {
  if (data.work === 'mobile') {
    if (data.callVolume === 'low') {
      return 'Mobile Base'
    } else if (data.callVolume === 'medium') {
      return 'Mobile Growth'
    } else if (data.callVolume === 'high') {
      return 'Mobile Boss'
    }
  } else if (data.outbound === 'yes') {
    if (data.callVolume === 'low') {
      return 'Base'
    } else if (data.callVolume === 'medium') {
      return 'Plus'
    } else if (data.callVolume === 'high') {
      return 'Pro'
    }
  }
  if (data.callVolume === 'low') {
    return 'Landline Base'
  } else if (data.callVolume === 'medium') {
    return 'Landline Plus'
  } else if (data.callVolume === 'high') {
    return 'Landline Pro'
  }
}

class QuizComponent extends Component {
  state = {
    open: false,
    result: undefined,
  }
  toggleOpen = () =>
    this.setState({
      open: !this.state.open,
    })
  submit = data => {
    const numberType = data.companyType === 'call-centre' ? '1800' : '1300'

    const productType = data.outbound === 'yes' ? 'Phone System' : 'Number'

    const planName = getPlanName(data)

    const planString = `${numberType} ${productType} on the ${planName} plan.`

    this.setState({
      result: data.callFlows === 'high' ? [planString, 'Add ons: Call flows'] : [planString],
    })
  }
  render() {
    const { handleSubmit } = this.props
    const { open, result } = this.state
    return (
      <Form onSubmit={handleSubmit(this.submit)}>
        <Markdown text={this.props.text} color={this.props.color} style={{ textAlign: 'center' }} />
        <AnimationFade in={open}>
          <div className={cn(s.container)}>
            <Button icon size="sm" onClick={this.toggleOpen} className={s.close}>
              <IconCloseThin size={32} />
            </Button>
            {questions.map(question => (
              <div key={question.id} className={s.question}>
                <div className={cn(sText.heading3, sText.center, s.questionTitle)}>
                  {question.label}
                </div>
                <Row className={cn(sLay['layout-row'], sLay['layout-align-center'])}>
                  {question.options.map(option => (
                    <Col
                      key={option.value}
                      className={cn(
                        sLay['layout-column'],
                        sLay['layout-align-start-center'],
                        s.option
                      )}
                    >
                      <Field name={question.id} radioValue={option.value} component={Radio} />
                      <div className={s.label}>{option.label}</div>
                    </Col>
                  ))}
                </Row>
              </div>
            ))}
            <div className={cn(sLay['layout-column'], sLay['layout-align-start-center'])}>
              <Button color="tertiary" type="submit">
                Tell me what I need
              </Button>
            </div>
            {result && (
              <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}>
                <div className={cn(sText.center, s.recs)}>
                  <div className={cn(sText.heading4, sMarg.mv30)}>Recommendations:</div>
                  <div className={sText.descrip2}>
                    {result.map((item, idx) => (
                      <div key={idx}>{item}</div>
                    ))}
                    <br />
                    <br />
                    <Button color="tertiary" to="/plans">
                      Show me the plans
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </AnimationFade>
        {!open && (
          <div className={cn(sLay['layout-column'], sLay['layout-align-start-center'])}>
            <Button color="tertiary" size="lg" onClick={this.toggleOpen}>
              Get started
            </Button>
          </div>
        )}
      </Form>
    )
  }
}

export default reduxForm({
  form: 'quizForm',
  initialValues: {
    companyType: 'company',
    callVolume: 'medium',
    callFlows: 'medium',
    work: 'landline',
    outbound: 'no',
  },
})(QuizComponent)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Quiz/Quiz.jsx